import { ia, mString } from 'lib/helpers/utility';

import { sumProcedureInsPaid } from './utils';

export const formatProcedure = (procedure, claim, index, refId, refType, toMString = true) => {
  const date = procedure?.from_date;
  const formattedPayerOrder =
    claim?.payer_order === null ? 'primary' : claim?.payer_order?.toLowerCase();
  const allAdjustments = [];

  if (procedure?.[formattedPayerOrder]) {
    procedure[formattedPayerOrder].forEach((insEntry) => {
      if (insEntry?.ref_type === refType && insEntry?.ref_id === refId) {
        if (insEntry?.ins_adj) {
          allAdjustments.push(...insEntry.ins_adj);
        }
        if (insEntry?.pt_adj) {
          allAdjustments.push(...insEntry.pt_adj);
        }
      }
    });
  }

  const totalInsPaid = sumProcedureInsPaid(procedure, refId, refType, claim?.payer_order);
  const paid = toMString
    ? totalInsPaid !== undefined && totalInsPaid !== null
      ? mString(totalInsPaid || 0)
      : mString(procedure.paid || 0)
    : totalInsPaid !== undefined && totalInsPaid !== null
      ? totalInsPaid || 0
      : procedure.paid || 0;

  return {
    id: procedure.id,
    select: false,
    date,
    createdAt: claim.created_at,
    patientName: claim?.superbill?.patient?.fullName || '',
    procedure_code: procedure.procedure_code,
    provider: `Qty: ${procedure?.units || ''} Mods: ${procedure?.modifiers || ''}`,
    diagnosis: '',
    billed: mString(procedure.charge),
    adjustment: ia(allAdjustments) ? allAdjustments : procedure?.adjustment,
    paid,
    total_insurance_payment: totalInsPaid && mString(totalInsPaid),
    isClaimRow: false,
    claimId: claim.id,
    procedureIndex: index
  };
};
